import React, { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGoogleLogin } from 'react-google-login';

import { VerificationLayout } from '@thinknet-gmbh/platform-common-ui';
import { PlatformModulesEnum } from '@thinknet-gmbh/platform-common';

import { useAuthAxiosInstance } from 'src/pages/auth/auth.axios.instance';
import { SUB_ROUTES } from 'src/components/app/app-routes.constants';
import { useRouteQuery } from 'src/common/helpers';

const Verification: React.FC = () => {
  const { t } = useTranslation(['auth', 'common']);
  const navigate = useNavigate();
  const { googleAuth, microsoftAuth, verify, confirmEmailChange } = useAuthAxiosInstance();
  const { signIn } = useGoogleLogin({
    onSuccess: googleAuth,
    clientId: process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID || '',
  });

  const params = useRouteQuery();
  const token = params.get('token');

  useEffect(() => {
    if (token) {
      confirmEmailChange(token);
    }
  }, [token, confirmEmailChange]);

  return (
    <VerificationLayout
      t={t}
      googleAuth={signIn}
      microsoftAuth={microsoftAuth}
      module={PlatformModulesEnum.PLAN_WERK_MODULE}
      navigate={() => navigate(SUB_ROUTES.authForgotPassword)}
      verifyForm={verify}
    />
  );
};

export default Verification;
